import React, { useState, useEffect, useRef, useReducer } from 'react';
import { Accordion, AccordionPanel, Heading } from 'wt-ui';
import { Trans } from 'react-i18next';
import LoadingLayer from '../../components/LoadingLayer';
import API from '../../services/API';
import AssetClass from '../AssetClass';
import HeatMapHeader from '../../components/HeatMapHeader';

const getLastUpdatedDt = (data) => {
  try {
    return data[0].groups[0].underlyingList[0].lastUpdated;
  } catch (e) {
    return null;
  }
};

const nColumnsBasedOnWidth = (width) => {
  if (!width) {
    return 4;
  }

  if (width < 325) {
    // mobile
    return 2;
  }

  if (width < 425) {
    // mobile
    return 3;
  }
  if (width < 768) {
    // tablet
    return 5;
  }
  if (width < 1024) {
    // laptop
    return 7;
  }
  return 6; // large laptop/desktop
};

const getChangedTickers = (oldData, newData) => {
  const arr = [];
  if (oldData.length === 0) {
    return arr;
  }

  oldData.forEach((assetClass) => {
    assetClass.groups.forEach((group) => {
      group.underlyingList.forEach((u) => {
        const newChg = newData
          .find((x) => x.name === assetClass.name)
          .groups.find((x) => x.name === group.name)
          .underlyingList.find((x) => x.name === u.name);

        if (u.chg !== newChg.chg) {
          arr.push(newChg.name);
        }
      });
    });
  });

  return arr;
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'setData':
      return {
        ...state,
        blink: getChangedTickers(state.data, action.value),
        data: action.value,
      };
    default:
      throw new Error();
  }
};

const Content = () => {
  const [state, dispatch] = useReducer(reducer, {
    data: [],
    blink: ['EURO STOXX Banks'],
  });
  const [loading, setLoading] = useState(true);
  const [nColumns, setNColumns] = useState(6);
  const [activeIndex, setActiveIndex] = useState([0, 1, 2]);
  const groupWrapper = useRef(null);

  const loadContent = async () => {
    if (!loading) {
      setLoading(true);
    }
    const result = await API.getAssetClasses();

    if (!result) {
      return;
    }

    dispatch({ type: 'setData', value: result });
    setLoading(false);
  }; // end loadContent

  useEffect(() => {
    loadContent();
    setInterval(loadContent, 1000 * 10);

    // colapse asset classses if mobile / show equities onl
    const width = groupWrapper.current && groupWrapper.current.getBoundingClientRect().width;
    if (width && width < 480) {
      setActiveIndex([0]);
    }
    // set initial number of columns to render
    setNColumns(nColumnsBasedOnWidth(groupWrapper.current && groupWrapper.current.getBoundingClientRect().width));

    const handleResize = () => {
      const newWidth = groupWrapper.current && groupWrapper.current.getBoundingClientRect().width;
      const newNColumns = nColumnsBasedOnWidth(newWidth);
      setNColumns(newNColumns);
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div background="transparent" ref={groupWrapper}>
      {loading ? <LoadingLayer /> : <HeatMapHeader lastUpdated={getLastUpdatedDt(state.data)} />}
      <Accordion
        columns="small"
        multiple
        activeIndex={activeIndex}
        onActive={(newActiveIndex) => setActiveIndex(newActiveIndex)}
      >
        {state.data.map((assetClass) => (
          <AccordionPanel
            key={assetClass.name}
            label={
              <Heading level={3} style={{ margin: '0px' }}>
                <Trans>{assetClass.name}</Trans>
              </Heading>
            }
            style={{ marginTop: '20px' }}
          >
            <AssetClass key={assetClass.name} data={assetClass} blink={state.blink} nColumns={nColumns} />
          </AccordionPanel>
        ))}
      </Accordion>
    </div>
  );
};
/*
header={renderAccordionHeader(assetClass.name, activeIndex.includes(index))}
 <Box background="transparent" gap="xsmall">
        {loading ? <LoadingLayer /> : <HeatMapScale />}
        {data.map((assetClass) => (
          <AssetClass key={assetClass.name} data={assetClass} nColumns={nColumns} />
        ))}
      </Box>
*/
export default Content;
